module.exports = __webpack_public_path__ + "img/9.6高栏车.f7510b11.jpg";